import React, { useState } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { sendAnalytics } from "../../../action/homeAction";


const DailyProgramAckPopupV2_Extended = (props) => {

    const { t } = props
    const [showSingleEvent, setShowSingleEvent] = useState(false)
    const [showSingleEventData, setShowSingleEventData] = useState({});


    const handleShowSingleDailyProgramme = (dailyProgrammeData) => {
        setShowSingleEvent(true);
        setShowSingleEventData(dailyProgrammeData);
    }

    return (
        <>
            <section class="overlay">

                {
                    showSingleEvent ?

                        <div class="overlay-window-container">
                            <div class="overlay-window">
                                <div class="overlay-content padding-0">
                                    <div class="overlay-header">
                                        <div class="overlay-header-title xw-65">
                                            <h2>{showSingleEventData.title}</h2>
                                        </div>
                                    </div>
                                    <div class="overlay-header-body form-row margin-top-0 align-left daily-popup-sub-container">
                                        <p>{showSingleEventData.description}</p>

                                        {showSingleEventData.child_policy && showSingleEventData.child_policy != "" && 
                                        <div class="stay-info">
                                            <div className="stay-daily-popup">
                                                <p class="heading">{t('resReservationV2.dailyProgramAck.child_policy')}</p>
                                                <p dangerouslySetInnerHTML={{__html: showSingleEventData.child_policy}}></p>
                                            </div>
                                        </div>}

                                        {showSingleEventData.spend_policy && showSingleEventData.spend_policy != "" && 
                                        <div class="stay-info">
                                            <div className="stay-daily-popup">
                                                <p class="heading">{t('resReservationV2.dailyProgramAck.spend_policy')}</p>
                                                <p dangerouslySetInnerHTML={{__html: showSingleEventData.spend_policy}}></p>
                                            </div>
                                        </div>}

                                        {showSingleEventData.table_holding_policy && showSingleEventData.table_holding_policy != "" && 
                                        <div class="stay-info">
                                            <div className="stay-daily-popup">
                                                <p class="heading">{t('resReservationV2.dailyProgramAck.table_holding_policy')}</p>
                                                <p dangerouslySetInnerHTML={{__html: showSingleEventData.table_holding_policy}} ></p>
                                            </div>
                                        </div>}

                                        <form>
                                            <div class="form-row">
                                                {showSingleEventData.cuisine && showSingleEventData.cuisine != "" && 
                                                <label>
                                                    {t("resReservationV2.dailyProgramAck.cuisine")}
                                                    <span dangerouslySetInnerHTML={{__html: showSingleEventData.cuisine}}></span>
                                                </label>}

                                                {showSingleEventData.dress_code && showSingleEventData.dress_code != "" && 
                                                <label>
                                                    {t("resReservationV2.dailyProgramAck.dress_code")}
                                                    <span dangerouslySetInnerHTML={{__html: showSingleEventData.dress_code}}></span>
                                                </label>}

                                                {showSingleEventData.price_point && showSingleEventData.price_point != "" && 
                                                <label>
                                                    {t("resReservationV2.dailyProgramAck.price_point")}
                                                    <span dangerouslySetInnerHTML={{__html: showSingleEventData.price_point}}></span>
                                                </label>}
                                            </div>
                                        </form>

                                    </div>
                                </div>
                                <div class="overlay-controls">
                                    <button onClick={() => setShowSingleEvent(false)} class="button secondary">{t('resReservationV2.back')}</button>
                                </div>
                            </div>
                        </div>
                        :
                        <div class="overlay-window-container">
                            <div class="overlay-window">

                                <div class="overlay-content padding-0">
                                    <div class="overlay-header">
                                        <div class="overlay-header-title">
                                            <h2 style={{ color: "#000 !important" }}>{t('resReservationV2.dailyProgramAck.heading1')}</h2>
                                        </div>
                                    </div>

                                    <div class="overlay-header-body multi-msg">
                                        {
                                            props.selectedTimeDailyProgrammeData.map((dailyProgramme) => {
                                                return (
                                                    <div class="form-row" onClick={() => handleShowSingleDailyProgramme(dailyProgramme)} >
                                                        <div class="overlay-body-header-container">
                                                            <h3 style={{ color: "#000 !important" }}>{dailyProgramme.title} <span className="amount">{dailyProgramme.price_point}</span></h3>
                                                            <p dangerouslySetInnerHTML={{__html: dailyProgramme.description}}></p>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }

                                        <p>{ props.selectedTimeDailyProgrammeData.length == 1 ? t('resReservationV2.dailyProgramAck.single_program_ack_question') : t('resReservationV2.dailyProgramAck.multi_program_ack_question')}</p>
                                    </div>
                                </div>

                                <div class="overlay-controls">
                                    <button onClick={() => props.proceed()} class="button">{t('resReservationV2.proceed')}</button>
                                    <button onClick={() => props.close()} class="button secondary">{t('resReservationV2.close')}</button>
                                </div>
                            </div>

                        </div>
                }

            </section>
        </>
    )
}


const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
    }
}

export default connect(mapStateToProps, { sendAnalytics })(withTranslation('translations')(DailyProgramAckPopupV2_Extended));